//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    userId: {
      type: [String, Number],
      default: '',
    }
  },
  data(){
    return {
      dark: false,
      darkObserver: null
    }
  },
  computed: {
  },
  watch: {
    "$route.query": function () {
      this.deleteObserver()
      this.createObserver()
    }
  },
  mounted() {
    this.createObserver()
  },
  beforeDestroy() {
    this.deleteObserver()
  },
  methods: {
    deleteObserver() {
      document.querySelectorAll('.dark-trigger').forEach(elem => {
        if(this.darkObserver) {
          this.darkObserver.unobserve(elem);
        }
      })
    },
    createObserver() {
      const profileAside = document.querySelector('.profile-info-links')
      setTimeout(() => {
        const profileAsideOffset = profileAside.offsetHeight + profileAside.offsetTop
        const margin = (window.innerHeight - profileAsideOffset) * -1 + 'px'
        const options = {
          root: null,
          rootMargin: `1px 0px ${margin} 0px`,
          threshold: 0
        }

        this.darkObserver = new IntersectionObserver((entries, observer) => {
          for(let i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              this.dark = true
              return
            }
          }
          this.dark = false
        }, options)

        document.querySelectorAll('.dark-trigger').forEach(elem => {
          this.darkObserver.observe(elem)
        })
      }, 500)
    }
  }
}
